import styled from 'styled-components';
import colors from 'utils/colors';

export const ScrollWrapper = styled.div`
  padding: 2rem;
  overflow-y: auto;
  height: 100%;
  width: 100%;
`;

export const QuestionDetails = styled.div`
  border-top: 1px solid ${colors.lightestGray};
  border-radius: 0 0 5px;
  background: ${colors.whiteGray};
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const DetailItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 2rem;
`;

export const DetailItemTitle = styled.span`
  color: ${colors.lightGray};
  font-size: 0.8rem;
  padding: 0.5rem 0;
`;

export const DetailItemValue = styled.span`
  color: ${colors.gray};
  font-size: 1.2rem;
  padding-bottom: 0.5rem;
`;

export const AnswerWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 1rem;
  color: ${colors.gray};
  background-color: ${colors.white};
`;

export const Wrapper = styled.div`
  padding: 0rem;
`;

export const Title = styled.div`
  letter-spacing: 0.7px;
  font-size: 1rem;
  font-weight: 400;
  color: ${colors.gray};
  max-width: 30rem;

  @media screen and (min-width: 760px) and (max-width: 1050px) {
    font-size: 0.8rem;
  }

  @media screen and (min-width: 1051px) and (max-width: 1250px) {
    font-size: 0.9rem;
  }
`;

export const Controls = styled.div`
  width: ${props => props.width || '4rem'};
  display: flex;
  justify-content: space-between;
  color: ${colors.darkGray};
  align-items: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
`;

export const Section = styled.section`
  border-bottom: 1px solid ${colors.lightestGray};
  margin-bottom: 1rem;
  background-color: #fff;

  &:not(:first-of-type) {
    border-top: 1px solid ${colors.lightestGray};
  }
`;

export const Status = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;

  @media screen and (min-width: 760px) and (max-width: 1050px) {
    min-width: 7rem;
    max-width: 10rem;
    justify-content: flex-start;
  }

  @media screen and (min-width: 1051px) and (max-width: 1250px) {
    min-width: 8rem;
    max-width: 9rem;
    justify-content: flex-start;
  }
`;

export const StatusLabel = styled.div`
  font-size: 0.9rem;
  color: ${colors.lightGray};

  @media screen and (min-width: 760px) and (max-width: 1050px) {
    font-size: 0.7rem;
  }

  @media screen and (min-width: 1051px) and (max-width: 1250px) {
    font-size: 0.8rem;
  }
`;

export const StatusValue = styled.div`
  font-size: 1.1rem;
  color: ${colors.gray};
  font-weight: 300;
  margin: 0 0.5rem;

  @media screen and (min-width: 760px) and (max-width: 1050px) {
    font-size: 0.9rem;
  }

  @media screen and (min-width: 1051px) and (max-width: 1250px) {
    font-size: 1rem;
  }
`;

export const PageNumbers = styled.span`
  font-size: 0.8rem;
  font-weight: 300;
`;

export const Remove = styled.div`
  padding: 1rem;
  text-align: center;
  color: ${props => (props.success ? colors.green : colors.red)};
  width: 20%;
  border: 1px solid transparent;
  margin: 1rem auto;
  border-radius: 5px;
  &:hover {
    color: ${props => (props.success ? colors.darkGreen : colors.darkRed)};
    cursor: pointer;
    border: 1px solid
      ${props => (props.success ? colors.darkGreen : colors.darkRed)};
  }
`;

export const BlueText = styled.span`
  color: ${colors.primary};
  cursor: pointer;
`;

export const BreadCrumb = styled.div`
  width: 100%;
  padding: 2rem 1rem 0;
  color: ${colors.primary};
  cursor: pointer;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 300;
`;

export const QuestionLabel = styled.span`
  font-size: 0.8rem;
  color: ${colors.lightGray};
  display: block;
`;

export const TableRow = styled.tr`
  border: none;
  border-bottom: 1px solid ${colors.lightestGray};
  border-top: 1px solid ${colors.lightestGray};
  background: ${props => props.background || '#fff'};
  &:last-child {
    border-bottom: none;
  }
  width: 100%;
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: ${props => props.align || 'center'};
  background-color: ${colors.white};
  padding: ${props => props.padding || '0.75rem 1rem'};
`;

export const HeaderControls = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${colors.gray};
  width: 25%;
  align-items: center;
`;

export const Question = styled.span`
  font-size: 1rem;
  padding: 0.7rem 0 1.2rem;
  color: ${colors.gray};
  display: block;
`;
